import { useQuery } from "@tanstack/react-query";

import { createActivationApi } from "app/pages/activation/services/api";
import type { PriorityAlerts } from "app/pages/activation/types/api";

export const PRIORITY_ALERTS_KEY = "priority-alerts";

export const usePriorityAlertsQuery = (activationId: string, enabled = true) => {
    return useQuery<PriorityAlerts>({
        queryKey: [PRIORITY_ALERTS_KEY, activationId],
        queryFn: () => {
            const api = createActivationApi();

            return api.homeWithData.getPriorityAlerts(activationId);
        },
        enabled: !!activationId && !!enabled,
        refetchOnMount: true,
    });
};
